var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8c0-4.418 3.528-8 7.88-8s7.88 3.582 7.88 8-3.528 8-7.88 8S0 12.418 0 8z",
    fill: "#CE1312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.982 6.39s-.082-.601-.334-.866c-.32-.347-.677-.349-.84-.369-1.175-.088-2.937-.088-2.937-.088h-.004s-1.762 0-2.936.088c-.165.02-.522.022-.842.37-.251.264-.333.865-.333.865s-.084.705-.084 1.411v.662c0 .705.084 1.411.084 1.411s.082.6.333.865c.32.348.74.337.926.373.672.067 2.854.088 2.854.088s1.764-.003 2.938-.091c.164-.02.522-.022.841-.37.252-.264.334-.865.334-.865s.084-.706.084-1.411V7.8c0-.706-.084-1.411-.084-1.411z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1312",
    d: "M7.002 9.264v-2.45l2.268 1.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.954c8c1eca53d5e9a863a31a1befcaea.svg";
export { ForwardRef as ReactComponent };